export interface MangaArticle {
  id: string;
  title: string;
  category: string;
  coverImage: string;
  description: string;
  author: string;
  status: string;
  updateTime: string;
  rating: number;
  views: number;
  tags: string[];
  content: string;
  chapters: { title: string; updateTime: string }[];
}

export const mangaArticles: MangaArticle[] = [
  {
    id: 'article-1',
    title: '星辰变',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manga%20illustration%20of%20a%20young%20cultivator%20with%20flowing%20dark%20hair%20standing%20on%20a%20mountain%20peak%20under%20a%20starry%20night%20sky%2C%20dramatic%20cosmic%20energy%20surrounding%20him%2C%20ethereal%20glowing%20aura%2C%20elegant%20traditional%20robes%2C%20soft%20golden%20and%20deep%20indigo%20color%20palette%2C%20anime%20art%20style%2C%20highly%20detailed%2C%20cinematic%20composition&width=800&height=600&seq=manga-cover-01&orientation=portrait',
    description: '一名普通少年意外获得上古星辰传承，从此踏上逆天修行之路。浩瀚星空，万族争锋，且看他如何以凡人之躯，比肩神明！',
    author: '天蚕土豆',
    status: '连载中',
    updateTime: '2026-08-08',
    rating: 9.5,
    views: 1280000,
    tags: ['修仙', '热血', '逆袭', '星辰变'],
    content: '',
    chapters: [
      { title: '第1章 星辰陨落', updateTime: '2026-07-01' },
      { title: '第2章 意外传承', updateTime: '2026-07-03' },
      { title: '第3章 初入修炼', updateTime: '2026-07-06' },
      { title: '第4章 宗门试炼', updateTime: '2026-07-10' },
      { title: '第5章 突破瓶颈', updateTime: '2026-07-14' },
    ],
  },
  {
    id: 'article-2',
    title: '甜蜜陷阱',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20illustration%20of%20a%20couple%20under%20cherry%20blossom%20trees%2C%20gentle%20spring%20sunlight%20filtering%20through%20pink%20petals%2C%20the%20girl%20with%20long%20flowing%20hair%20and%20school%20uniform%2C%20the%20boy%20with%20gentle%20smile%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20shojo%20manga%20style%2C%20highly%20detailed%2C%20emotional&width=800&height=600&seq=manga-cover-02&orientation=portrait',
    description: '高冷校草与元气少女的意外相遇，一段甜蜜又搞笑的校园恋爱物语就此展开。原来最甜的陷阱，是爱情本身。',
    author: '顾漫',
    status: '已完结',
    updateTime: '2026-08-05',
    rating: 9.2,
    views: 980000,
    tags: ['校园', '甜宠', '恋爱', '搞笑'],
    content: '',
    chapters: [
      { title: '第1话 命运的相遇', updateTime: '2026-05-01' },
      { title: '第2话 意外的同桌', updateTime: '2026-05-08' },
      { title: '第3话 心跳加速', updateTime: '2026-05-15' },
      { title: '第4话 图书馆的秘密', updateTime: '2026-05-22' },
      { title: '最终话 永远在一起', updateTime: '2026-06-30' },
    ],
  },
  {
    id: 'article-3',
    title: '暗影猎手',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20manga%20illustration%20of%20a%20powerful%20warrior%20in%20dark%20armor%20wielding%20twin%20blades%2C%20leaping%20through%20a%20rainy%20urban%20landscape%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20dramatic%20lighting%2C%20intense%20expression%2C%20dark%20and%20vibrant%20color%20scheme%2C%20seinen%20manga%20style%2C%20highly%20detailed%2C%20explosive%20energy&width=800&height=600&seq=manga-cover-03&orientation=portrait',
    description: '在黑暗都市的阴影中，一位独行猎手追猎着潜伏于人类社会中的超自然生物。刀光剑影之间，真相逐渐浮出水面。',
    author: '江南',
    status: '连载中',
    updateTime: '2026-08-07',
    rating: 9.3,
    views: 1520000,
    tags: ['都市', '战斗', '超自然', '暗黑'],
    content: '',
    chapters: [
      { title: '第1话 夜幕降临', updateTime: '2026-06-01' },
      { title: '第2话 猎杀时刻', updateTime: '2026-06-08' },
      { title: '第3话 血色月光', updateTime: '2026-06-15' },
      { title: '第4话 同盟缔结', updateTime: '2026-06-22' },
      { title: '第5话 宿命对决', updateTime: '2026-07-01' },
    ],
  },
  {
    id: 'article-4',
    title: '斗罗大陆外传',
    category: 'shounen',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20manga%20illustration%20of%20a%20young%20hero%20surrounded%20by%20colorful%20spirit%20rings%2C%20standing%20on%20a%20floating%20island%20with%20waterfalls%2C%20magical%20energy%20swirling%20around%2C%20determined%20expression%2C%20vibrant%20and%20bright%20color%20palette%2C%20adventure%20manga%20style%2C%20highly%20detailed%2C%20grand%20scale&width=800&height=600&seq=manga-cover-04&orientation=portrait',
    description: '斗罗大陆的传奇仍在继续！新一代魂师踏上征程，在更广阔的天地中追寻属于自己的荣耀与梦想。',
    author: '唐家三少',
    status: '连载中',
    updateTime: '2026-08-08',
    rating: 9.6,
    views: 2100000,
    tags: ['玄幻', '热血', '魂师', '斗罗'],
    content: '',
    chapters: [
      { title: '第1话 新的征程', updateTime: '2026-04-01' },
      { title: '第2话 魂环觉醒', updateTime: '2026-04-10' },
      { title: '第3话 学院风云', updateTime: '2026-04-20' },
      { title: '第4话 初次交锋', updateTime: '2026-05-01' },
      { title: '第5话 团队之力', updateTime: '2026-05-15' },
    ],
  },
  {
    id: 'article-5',
    title: '搞笑一家人',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20heartwarming%20manga%20illustration%20of%20a%20quirky%20family%20having%20a%20chaotic%20dinner%20together%2C%20exaggerated%20facial%20expressions%2C%20food%20flying%20everywhere%2C%20bright%20and%20warm%20color%20palette%2C%20comedic%20slice%20of%20life%20manga%20style%2C%20highly%20detailed%2C%20lively%20and%20energetic%20atmosphere&width=800&height=600&seq=manga-cover-05&orientation=portrait',
    description: '四个性格迥异的室友住在同一屋檐下，每天上演令人捧腹的日常闹剧。笑中有泪，温暖治愈！',
    author: '白茶',
    status: '连载中',
    updateTime: '2026-08-06',
    rating: 8.9,
    views: 750000,
    tags: ['日常', '搞笑', '治愈', '室友'],
    content: '',
    chapters: [
      { title: '第1话 新室友驾到', updateTime: '2026-03-01' },
      { title: '第2话 厨房大作战', updateTime: '2026-03-08' },
      { title: '第3话 谁偷吃了蛋糕', updateTime: '2026-03-15' },
      { title: '第4话 停电之夜', updateTime: '2026-03-22' },
      { title: '第5话 宠物大危机', updateTime: '2026-03-30' },
    ],
  },
  {
    id: 'article-6',
    title: '迷雾之城',
    category: 'suspense',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20manga%20illustration%20of%20a%20detective%20standing%20in%20a%20foggy%20alleyway%20at%20night%2C%20holding%20a%20flashlight%2C%20shadows%20lurking%20in%20the%20background%2C%20noir%20aesthetic%2C%20muted%20and%20dark%20color%20palette%20with%20accents%20of%20amber%20light%2C%20mystery%20thriller%20manga%20style%2C%20highly%20detailed%2C%20tense%20atmosphere&width=800&height=600&seq=manga-cover-06&orientation=portrait',
    description: '一座被迷雾笼罩的城市，接连发生离奇失踪案。私家侦探林墨深入调查，却发现自己正一步步踏入更深的谜团。',
    author: '紫金陈',
    status: '连载中',
    updateTime: '2026-08-04',
    rating: 9.1,
    views: 680000,
    tags: ['悬疑', '推理', '都市', '犯罪'],
    content: '',
    chapters: [
      { title: '第1话 失踪者', updateTime: '2026-05-01' },
      { title: '第2话 第一条线索', updateTime: '2026-05-10' },
      { title: '第3话 迷雾深处', updateTime: '2026-05-20' },
      { title: '第4话 嫌疑人', updateTime: '2026-06-01' },
      { title: '第5话 真相浮现', updateTime: '2026-06-15' },
    ],
  },
  {
    id: 'article-7',
    title: '机械纪元',
    category: 'scifi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20manga%20illustration%20of%20a%20cyborg%20girl%20with%20mechanical%20limbs%20in%20a%20high-tech%20city%2C%20holographic%20displays%20and%20flying%20vehicles%20in%20the%20background%2C%20neon%20blue%20and%20silver%20accents%2C%20sleek%20futuristic%20design%2C%20cyberpunk%20manga%20style%2C%20highly%20detailed%2C%20immersive%20atmosphere&width=800&height=600&seq=manga-cover-07&orientation=portrait',
    description: '公元2150年，人类与AI共存的时代。少女小夜在一次意外中发现自己拥有与机械沟通的能力，一场改变世界格局的冒险就此展开。',
    author: '刘慈欣',
    status: '连载中',
    updateTime: '2026-08-03',
    rating: 9.4,
    views: 860000,
    tags: ['科幻', 'AI', '未来', '冒险'],
    content: '',
    chapters: [
      { title: '第1话 觉醒之日', updateTime: '2026-04-01' },
      { title: '第2话 钢铁都市', updateTime: '2026-04-15' },
      { title: '第3话 机械之心', updateTime: '2026-05-01' },
      { title: '第4话 反叛者', updateTime: '2026-05-20' },
      { title: '第5话 新世界', updateTime: '2026-06-10' },
    ],
  },
  {
    id: 'article-8',
    title: '武道至尊',
    category: 'shounen',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20martial%20arts%20manga%20illustration%20of%20a%20fighter%20in%20traditional%20martial%20arts%20uniform%20performing%20an%20explosive%20punch%2C%20energy%20waves%20radiating%2C%20ancient%20temple%20background%2C%20dramatic%20perspective%2C%20warm%20orange%20and%20red%20color%20palette%2C%20shounen%20battle%20manga%20style%2C%20highly%20detailed%2C%20dynamic%20movement&width=800&height=600&seq=manga-cover-08&orientation=portrait',
    description: '少年林风自幼习武，在一次比试中被废去修为。但他并未放弃，以钢铁般的意志重新踏上武道巅峰！',
    author: '萧鼎',
    status: '连载中',
    updateTime: '2026-08-07',
    rating: 9.0,
    views: 920000,
    tags: ['武侠', '热血', '修炼', '逆袭'],
    content: '',
    chapters: [
      { title: '第1话 天才坠落', updateTime: '2026-06-01' },
      { title: '第2话 涅槃重生', updateTime: '2026-06-12' },
      { title: '第3话 初露锋芒', updateTime: '2026-06-25' },
      { title: '第4话 擂台争霸', updateTime: '2026-07-08' },
      { title: '第5话 名动天下', updateTime: '2026-07-22' },
    ],
  },
];